<template>
  <div>
    <!--footer -->
    <footer>
      <section class="footer footer_w3layouts_section_1its py-5">
        <div class="container py-md-4">
          <div class="footer-grid_section text-center" data-aos="zoom-in">
            <div class="footer-title mb-3">
              <a href="#">
                <i>
                  <img
                    style="height: 100px"
                    src="images/facicon-2.png"
                    alt=""
                  />
                </i>
                LogikTech
              </a>
            </div>
            <div class="footer-text">
              <p>
                Nous transformons des idées en réalité numérique, en alliant
                expertise technologique et créativité, pour propulser votre
                entreprise vers de nouveaux sommets numériques.
              </p>
            </div>
            <ul class="social_section_1info">
              <li class="mb-2 facebook">
                <a href="https://www.facebook.com/LogikTechSarl" target="_blank"
                  ><i class="fab mr-1 fa-facebook-f"></i>facebook</a
                >
              </li>
              <li class="mb-2 twitter">
                <a target="_blank" href="https://wa.me/2290194749156"
                  ><i class="fab mr-1 fa-whatsapp"></i>whatsapp</a
                >
              </li>
              <li class="google">
                <a href="mailto:etech.lawson@gmail.com"
                  ><i class="fab mr-1 fa-google-plus-g"></i>google</a
                >
              </li>
              <li class="linkedin">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/t%C3%A8vi-lawson-796680122/"
                  ><i class="fab mr-1 fa-linkedin-in"></i>linkedin</a
                >
              </li>
            </ul>
          </div>

          <div class="row footer-top mt-md-5 mt-4">
            <div
              class="col-lg-4 col-md-6 footer-grid_section_1its_w3"
              data-aos="fade-right"
            >
              <div class="footer-title">
                <h3>Adresses</h3>
              </div>
              <div class="footer-text">
                <p>Adresse : Sikècodji, Cotonou, Bénin</p>
                <p>Phone : +229 01 947 491 56</p>
                <p>
                  Email :
                  <a href="mailto:etech.lawson@gmail.com">contact@logik-tech.com</a>
                </p>
                <p>Whatsapp : +229 (01 6303 8000 / 01 947 491 56)</p>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-6 mt-md-0 mt-4 footer-grid_section_1its_w3"
              data-aos="fade-up"
            >
              <div class="footer-title">
                <h3>Liens directs</h3>
              </div>
              <div class="row">
                <ul class="col-6 links">
                  <li><a href="#choose" class="scroll">Pourquoi nous ? </a></li>
                  <li><a href="#pricing" class="scroll">Nos formations</a></li>
                  <li><a href="#faq" class="scroll">Nos réalisations </a></li>
                  <li><a href="#contact" class="scroll">Contact </a></li>
                </ul>
                <ul class="col-6 links">
                  <li><a href="#faq" class="scroll">Nos réalisations </a></li>
                  <li><a target="_blank" href="https://logik-tech.com/cv">CV Professionnel </a></li>
                  <li><a target="_blank" href="https://logik-tech.com/courses">Cours en ligne </a></li>
                  <li><a target="_blank" href="https://logik-tech.com/epub">Nos Livres </a></li>
                </ul>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-12 mt-lg-0 mt-4 col-sm-12 footer-grid_section_1its_w3"
              data-aos="fade-left"
            >
              <div class="footer-title">
                <h3>Newsletter</h3>
              </div>
              <div class="footer-text">
                <p>
                  En vous inscrivant à notre newsletter, vous recevrez toujours
                  nos dernières nouvelles et mises à jour.
                </p>
                <form @submit.prevent="submitNewsletter">
                  <input
                    type="email"
                    name="email"
                    v-model="newsletter.email"
                    placeholder="Entrez votre email ici ..."
                    required="tre"
                  />
                  <button type="submit" class="btn1">
                    <i class="fas fa-paper-plane" aria-hidden="true"></i>
                  </button>
                  <div class="clearfix"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
    <!-- //footer -->

    <!-- copyright -->
    <div class="cpy-right text-center py-3">
      <p class="">
        © 2023 LogikTech. Tous droits réservés | Designed by
        <a href="https://logik-tech.com"> LogikTech.</a>
      </p>
    </div>
    <!-- //copyright -->

    <!-- Vertically centered Modal -->
    <div
      class="modal fade"
      id="exampleModalCenter1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenter1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title text-capitalize text-center"
              id="exampleModalLongTitle"
            >
              <img src="images/favicon.png" style="height: 75px" alt="" />
              LogikTech
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img
              src="images/banner-2.jpg"
              class="img-fluid mb-3"
              alt="Modal Image"
            />
            <p style="text-align: justify">
              Nous sommes une entreprise de
              <b style="color: #138a92">formation en informatique</b>, composée
              d’experts en informatique, de
              <b style="color: #138a92">développeurs de logiciels</b> et de
              <b style="color: #138a92">plateformes web</b>, de rédacteurs web,
              d’ingénieur en réseau et de spécialistes en sécurité. Nous avons
              acquis une expertise solide en : développement de logiciels,
              Services en Cloud, Sécurité Informatique,
              <b style="color: #138a92">Rédaction Web</b>, Graphisme et Montages
              de vidéos.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- //Vertically centered Modal -->

    <!-- video Modal Popup -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Video Descriptive
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body video">
            <iframe src="https://player.vimeo.com/video/43982091"></iframe>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- //video Model Popup -->

    <!--/Login-->
    <div
      class="modal fade"
      id="exampleModalCenter2"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="login px-4 mx-auto mw-100">
              <h5 class="text-center mb-4">Login Now</h5>
              <form action="#" method="post">
                <div class="form-group">
                  <label class="mb-2">Email address</label>
                  <input
                    type="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder=""
                    required=""
                  />
                  <small id="emailHelp" class="form-text text-muted"
                    >We'll never share your email with anyone else.</small
                  >
                </div>
                <div class="form-group">
                  <label class="mb-2">Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleInputPassword1"
                    placeholder=""
                    required=""
                  />
                </div>
                <div class="form-check mb-2">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="exampleCheck1"
                  />
                  <label class="form-check-label" for="exampleCheck1"
                    >Check me out</label
                  >
                </div>
                <button type="submit" class="btn btn-primary submit mt-2">
                  Sign In
                </button>
                <p class="text-center pb-4">
                  <a
                    href="#"
                    data-toggle="modal2"
                    data-target="#exampleModalCenter"
                  >
                    Don't have an account?</a
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--//Login-->
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "Footer-Item",
  data() {
    return {
      newsletter: {
        email: "",
      },
    };
  },

  methods: {
    submitNewsletter() {
      document.getElementById("cover-spin").style.visibility = "visible";
      this.newsletter.email = " " + this.newsletter.email + " ";
      axios.post("https://localhost:1307/microservices/newsletter",this.newsletter)
        .then(function (response) {
            console.clear();
            this.clearNewsletter();
            document.getElementById("cover-spin").style.visibility = "hidden";
            this.showToatInfo(response.data.message);
          }.bind(this)
        ).catch(function (error) {
          console.log("here is the error -- > " + error);
          document.getElementById("cover-spin").style.visibility = "hidden";
          this.showToatError();
        }.bind(this));
    },

    showToatError() {
      toast.error(
        "Problème de connexion. Veuillez réessayer ultérieurement !!!",
        {
          autoClose: 2000,
        }
      );
    },

    showToatInfo(retour) {
      toast.info(retour, {
        autoClose: 2400,
      });
    },

    clearNewsletter() {
      this.newsletter.email = "";
    },
  },
};
</script>

<style scoped>
</style>